{
  "titles": {
    "menu": "Development tools",
    "developmentTools": "Development tools"
  },
  "messages": {
    "commandSuccessful": "Het commando is succesvol verstuurd",
    "commandFailed": "Er is helaas iets mis gegaan",
    "noToolsAvailable": "Er zijn helaas geen development tools beschikbaar",
    "commandConfirmation": "Weet je zeker dat je het commando wilt versturen? Dit kun je niet ongedaan maken."
  },
  "fields": {
    "labels": {
      "name": "Naam",
      "date": "Datum",
      "sentence": "Zin",
      "filter": "Filter",
      "amount": "Aantal",
      "truncate": "Database legen vóór het uitvoeren?",
      "onlySeederData": "Alleen seeder data?",
      "contractId": "Contract ID",
      "referenceNumber": "Referentienummer",
      "annualStatementYear": "Jaar",
      "entity": "Entiteit",
      "id": "ID",
      "iban": "IBAN",
      "file": "Bestand",
      "once": "Eenmalig",
      "granularity": "Granulariteit",
      "financeReceiverId": "Finance receiver ID",
      "loanReferenceNumber": "Referentienummer lening",
      "loanReferenceNumbers": "Referentienummers lening",
      "nrOfSuccessfulDirectDebits": "Aantal succesvolle automatische incasso's"
    },
    "hints": {
      "amount": "Vul een getal in"
    },
    "validationErrors": {
    }
  },
  "headers": {
    "labels": {
    }
  },
  "placeholders": {
    "selectTool": "Selecteer een tool"
  },
  "actions": {
    "send": "Versturen"
  }
}
